import React, { useState, useMemo } from 'react'
import { useQuery } from 'react-query'

import { useAuthentication } from '@hooks/useAuthentication'
import { usePenNameAction } from '@hooks/penName/usePenNameAction'
import { SettingPenNameProps } from './interface'

export function withSettingPenName(Component: React.FC<SettingPenNameProps>) {
  function WithSettingPenName() {
    const { user } = useAuthentication()
    const penNameClient = usePenNameAction()
    const [textSearch, setTextSearch] = useState('')
    const queryKey = ['my-pen-names', user.id]

    const { data = [] } = useQuery(
      queryKey,
      () => penNameClient.getPenNames(user.id),
      { enabled: !!user.id }
    )

    const penNameList = useMemo(() => {
      if (textSearch) {
        return data.filter(item =>
          item.firstPenName.toLowerCase().includes(textSearch.toLowerCase())
        )
      }

      return data
    }, [textSearch, data])

    function handleTextSearchChange(value: string) {
      setTextSearch(value)
    }

    const newProps = {
      userId: user.id,
      queryKey,
      penNameList,
      handleTextSearchChange,
    }

    return <Component {...newProps} />
  }
  return WithSettingPenName
}
